// extracted by css-extract-rspack-plugin
export default {"root":"SlTjA","active":"TVYS4","selected":"L_N7n","title":"Ynf3d","nameSection":"YUlBC","loadingSection":"Qw94N","xraySection":"J0L7a","description":"HrNFq"};